import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
export default function installBootstrap() {
    // Bootstrap ya se importa automáticamente
    console.log('Bootstrap plugin installed');
}
